import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
const initialState = {
    snackbar: {
        isOpen: false,
        type: 'success',
        message: '',
    },
    loading: {},
};
const reducer = createReducer(initialState, (builder) => builder
    // Handle snackbar actions
    .addCase(actions.openSnackbar, (state, { payload }) => {
    state.snackbar = { isOpen: true, type: payload.type, message: payload.message };
})
    .addCase(actions.closeSnackbar, (state) => {
    state.snackbar = initialState.snackbar;
})
    // Handle loading states
    .addMatcher((action) => action.type && !action.type.endsWith('_SUCCESS') && !action.type.endsWith('_FAIL'), (state, action) => {
    state.loading[action.type] = true;
})
    .addMatcher((action) => action.type && (action.type.endsWith('_SUCCESS') || action.type.endsWith('_FAIL')), (state, action) => {
    const baseActionType = action.type.replace(/_(SUCCESS|FAIL)$/, '');
    delete state.loading[baseActionType];
}));
export default reducer;
